import { Record, List } from 'immutable'

export const ReviewsSurveyUsedBy = Record({
  id: null,
  name: null,
  domain: null,
})

export const ReviewsSurvey = Record({
  id: null,
  name: null,
  competenciesQuestions: List(),
  openEndedQuestions: null,
  participantWelcomeText: null,
  reviewerWelcomeText: null,
  participantInfo: null,
  participantInstructions: null,
  reviewerInstructions: null,
  nominationInstructions: null,
  superiorMin: null,
  superiorMax: null,
  superiorInstructions: null,
  peerMin: null,
  peerMax: null,
  peerInstructions: null,
  employeeMin: null,
  employeeMax: null,
  employeeInstructions: null,
  participantEndText: null,
  reviewerEndText: null,
  isPublished: false,
  organizationId: null,
  usedBy: new ReviewsSurveyUsedBy(),
})
